import { useState } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useSendContactMutation } from '../slices/contactApiSlice';
import Message from '../Components/Message';
import Meta from '../Components/Meta';
import BackButton from "../Components/BackButton";

const ContactScreen = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [text, setText] = useState('');
  const [sendContact, { isLoading }] = useSendContactMutation();
  const [feedback, setFeedback] = useState({ type: '', text: '' });

  const onSubmit = async (e) => {
    e.preventDefault();
    const content = text.trim();
    if (!content) return;
    setText('');
    setFeedback({ type: '', text: '' });
    try {
      await sendContact({ name, email, message: content }).unwrap();
      setFeedback({
        type: 'success',
        text: 'Thanks! We received your message and will reply by email shortly.',
      });
    } catch (err) {
      setFeedback({
        type: 'danger',
        text: err?.data?.message || 'Failed to send. Please try again.',
      });
    }
  };

  return (
    <>
      <BackButton />
      <Meta title="Contact Us | KCC Parts Distribution" />
      <Row className="mb-4">
        <Col md={7}>
          <h1>Contact Us</h1>
          <p>
            KCC Parts Distribution is a Canadian-based supplier of OEM-quality and premium aftermarket automotive parts.
            We focus on accurate fitment, competitive pricing, and responsive customer service.
            If you’re looking for a dependable supplier or need help with an order, send us a message—our team
            typically replies within one business day.
          </p>
          {feedback.text && <Message variant={feedback.type}>{feedback.text}</Message>}
          <Card className="mb-3">
            <Card.Body>
              <Form onSubmit={onSubmit}>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group controlId="name">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Your name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="email">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="you@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="message" className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type your message…"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    required
                  />
                </Form.Group>
                <div className="d-grid">
                  <Button type="submit" disabled={isLoading}>
                    {isLoading ? 'Sending…' : 'Send message'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col md={5}>
          <h5>Company Details</h5>
          <Card>
            <Card.Body>
              <p className="mb-2"><strong>Head Office (Ottawa):</strong></p>
              <p className="mb-3">
                #114 15 Capella Court<br />
                Nepean, Ottawa, Ontario<br />
                K2E&nbsp;7X1
              </p>
              <p className="mb-1">
                <strong>Email</strong>:{' '}
                <a href="mailto:info@kccparts.ca">info@kccparts.ca</a>
              </p>
              <p className="mb-3">
                <strong>Phone</strong>:{' '}
                <a href="tel:+16134074708">+1 613 407 4708</a>
              </p>
              <p className="mb-0">
                We supply brake pads &amp; rotors, oil &amp; air filters, and more—built for quality and value.
                If you’re looking for a reliable supplier partner, we’d love to talk.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ContactScreen;
